/**
 * Captures the partner-handshake query params into the store slice the door
 * hooks read. Renders nothing. Must be mounted on EVERY route that can
 * receive an embed handshake directly, not only via the hub router.
 */
import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {useSearchParams} from "react-router";
import {setRealmHandoff} from "@/redux/rttr/rttrActions";

export function RealmHandshakeCapture(): null {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const realmUuid = searchParams.get("realm_uuid");
        if (!realmUuid) return;
        dispatch(setRealmHandoff({
            realmUuid,
            realmTs: searchParams.get("ts") ?? undefined,
            realmSig: searchParams.get("sig") ?? undefined,
        }));
    }, [searchParams, dispatch]);

    return null;
}

export default RealmHandshakeCapture;
